"use client"; // Error boundaries must be Client Components
import { useEffect } from "react";
import { errorConstants } from "@/constants/globalConstants";

export default function Error({ error, reset }) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div>
      <h2>{errorConstants.SOMETHING_WENT_WRONG}</h2>
      <button onClick={() => reset()}>{errorConstants.TRY_AGAIN_LATER}</button>
    </div>
  );
}
